import { ReactNode } from "react";

type BadgeVariant = "success" | "warning" | "error" | "info" | "neutral" | "purple";

interface BadgeProps {
  variant: BadgeVariant;
  children: ReactNode;
}

export function Badge({ variant, children }: BadgeProps) {
  const variantClasses: Record<BadgeVariant, string> = {
    success: "bg-green-100 text-green-700",
    warning: "bg-yellow-100 text-yellow-700",
    error: "bg-red-100 text-red-700",
    info: "bg-blue-100 text-blue-700",
    neutral: "bg-slate-100 text-slate-700",
    purple: "bg-purple-100 text-purple-700",
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${variantClasses[variant]}`}
    >
      {children}
    </span>
  );
}

export function getEstadoCasoBadgeVariant(
  estado: string
): BadgeVariant {
  const variants: Record<string, BadgeVariant> = {
    rol_listo: "neutral",
    en_preparacion: "info",
    confirmacion_presentacion: "purple",
    solicitud_administrativa: "warning",
    resolucion: "warning",
    ganado: "success",
    parcialmente_ganado: "warning",
    perdido: "error",
    cobro_facturacion: "success",
    tesoreria: "info",
    reclamo: "error",
    desistido: "neutral",
  };
  return variants[estado] || "neutral";
}

export function getEstadoReclamoBadgeVariant(
  estado: string
): BadgeVariant {
  const variants: Record<string, BadgeVariant> = {
    preparacion: "neutral",
    presentado: "info",
    en_tramite: "warning",
    resuelto: "success",
    desistido: "error",
  };
  return variants[estado] || "neutral";
}

export function getEstadoCobroBadgeVariant(
  estado: string
): BadgeVariant {
  const variants: Record<string, BadgeVariant> = {
    pendiente_certificado: "neutral",
    certificado_obtenido: "info",
    facturado: "purple",
    cobrado: "success",
    incobrable: "error",
  };
  return variants[estado] || "neutral";
}

export function getEstadoTesoreriaBadgeVariant(
  estado: string
): BadgeVariant {
  const variants: Record<string, BadgeVariant> = {
    esperando_pago: "warning",
    pago_recibido: "success",
    vencido: "error",
    en_gestion: "info",
  };
  return variants[estado] || "neutral";
}

export function getEstadoClienteBadgeVariant(
  estado: string
): BadgeVariant {
  return estado === "activo" ? "success" : "neutral";
}

export function getTipoClienteBadgeVariant(
  tipo: string
): BadgeVariant {
  return tipo === "cliente" ? "success" : "info";
}
